import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { BaseIcon } from '../BaseIcon';
export const Minus = ({ height = '12px', stroke, width = '12px', viewBox = '0 0 12 2', ...rest }) => {
    const { color } = useTheme();
    return (_jsx(BaseIcon, { height: height, width: width, viewBox: viewBox, ...rest, children: _jsx("path", { d: 'M10.335 1h-8.92', stroke: stroke || color.deprecated.black.primary, strokeWidth: '1.5', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'square' }) }));
};
//# sourceMappingURL=Minus.js.map